import type { Scenario } from '../domain/types';
import { osloLocalToUtc } from '../domain/time';

export const SEED_VERSION = 'hr-demo-seed-v1';
export const DEMO_WINDOW = { from: '2026-07-07', to: '2026-10-04' };
/** Frosset demoklokke: 4. oktober 2026 kl. 08.00 Europe/Oslo. */
export const DEMO_NOW_UTC = osloLocalToUtc(2026, 10, 4, 8, 0).toISOString();

export const SCENARIOS: Scenario[] = [
  {
    id: 'normal',
    name: 'Normal drift',
    shortName: 'Normal',
    description:
      '1. oktober mot 30. september. Stabile nøkkeltall, komplett datadekning og ingen store avvik.',
    seedVersion: SEED_VERSION,
    frozenNow: DEMO_NOW_UTC,
    recommendedFrom: '2026-10-01',
    recommendedTo: '2026-10-01',
    compareFrom: '2026-09-30',
    compareTo: '2026-09-30',
  },
  {
    id: 'flaskehals',
    name: 'Flaskehals',
    shortName: 'Flaskehals',
    description:
      '2. oktober mot 1. oktober. 25 % færre tonn, 12,5 % mer diesel og 50 % høyere liter per tonn. To ekstra stopptimer og mer tomgang hos DEMO-D01 og DEMO-L01 i overlappende tidsrom.',
    seedVersion: SEED_VERSION,
    frozenNow: DEMO_NOW_UTC,
    recommendedFrom: '2026-10-02',
    recommendedTo: '2026-10-02',
    compareFrom: '2026-10-01',
    compareTo: '2026-10-01',
  },
  {
    id: 'manglende-data',
    name: 'Manglende data',
    shortName: 'Manglende data',
    description:
      '3. oktober (planlagt demoskift) mot 2. oktober. Et forventet dieselintervall for DEMO-D02 mangler og maskinkilden er forsinket. Produksjonstall er komplette, men L/t, utslipp og kostanslag blir utilgjengelige.',
    seedVersion: SEED_VERSION,
    frozenNow: DEMO_NOW_UTC,
    recommendedFrom: '2026-10-03',
    recommendedTo: '2026-10-03',
    compareFrom: '2026-10-02',
    compareTo: '2026-10-02',
  },
];

export const DEFAULT_SCENARIO_ID = 'flaskehals';

export function getScenario(id: string | null | undefined): Scenario {
  return SCENARIOS.find((s) => s.id === id) ?? SCENARIOS.find((s) => s.id === DEFAULT_SCENARIO_ID)!;
}
